<fieldset
  class="flex flex-col border-0 p-0"
  [style.gap]="'var(--selectionbuttongroup-gap)'"
>
  @if (label) {
    <legend
      class="contents"
      [style.fontSize]="'var(--selectionbuttongroup-label-font-size)'"
      [style.fontWeight]="'var(--selectionbuttongroup-label-font-weight)'"
      [style.fontFamily]="'var(--selectionbuttongroup-label-font-family, inherit)'"
      [style.lineHeight]="'var(--selectionbuttongroup-label-line-height)'"
    >
      {{ label }}
    </legend>
  }
  <div
    class="grid grid-cols-1 gap-(--selectionbutton-gap)"
    [class]="'md:grid-cols-' + columns()"
  >
    @for (config of buttonConfigs(); track config.value) {
      <app-selection-button
        [config]="config"
        (action)="select(config.value)"
      />
    }
  </div>
</fieldset>
